import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import cx from 'classnames'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { CloseConfirmationModal } from 'apps/aiAutomation/components/Layout/components/CloseConfirmationModal'
import { useLayoutShift } from 'apps/aiAutomation/components/Layout/hooks/useLayoutShift'
import { LayoutContext, LayoutContextProps } from 'apps/aiAutomation/components/Layout/lib/context'
import {
  AiAutomationLayoutActions,
  AiAutomationLayoutSelectors,
} from 'apps/aiAutomation/store/layout'
import { useKeyDown } from 'common/core/coreHooks'

import cm from './styles.module.css'

interface LayoutProps {
  children: React.ReactNode
}

export const Layout = ({ children }: LayoutProps) => {
  const dispatch = useAppDispatch()

  const isSidebarOpen = useAppSelector(AiAutomationLayoutSelectors.getIsSidebarOpen)

  const sidebarRef = useRef<HTMLDivElement | null>(null)

  const closeSidebar = useCallback(() => {
    dispatch(AiAutomationLayoutActions.sidebarClosed())
  }, [dispatch])

  useKeyDown({
    key: 'Escape',
    onPress: closeSidebar,
  })

  const { defaultValuesSet } = useLayoutShift({ sidebarRef })

  const contextValue = useMemo<LayoutContextProps>(
    () => ({
      sidebarRef,
    }),
    [],
  )

  useEffect(() => {
    return () => {
      closeSidebar()
    }
  }, [closeSidebar])

  return (
    <LayoutContext.Provider value={contextValue}>
      <div className={cx('h-full', defaultValuesSet && 'layout_animatable')}>
        {children}

        {isSidebarOpen && (
          <div
            data-test-id="ai-flow/layout-backdrop"
            onClick={closeSidebar}
            className={cm.layout__backdrop}
          />
        )}

        <CloseConfirmationModal />
      </div>
    </LayoutContext.Provider>
  )
}
